export default "__VITE_ASSET__C1$HZEVT__"